import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ToasterService} from 'angular2-toaster/angular2-toaster';
import {FilesService} from "../../models/files/files.service";
import {Response, Http} from "@angular/http";
import {Observable} from "rxjs";
import {ApplicationUser} from "../../services/ApplicationUser";
import {dateTimeHelper} from "../../helpers/date";


@Component({
    selector: 'file-preview',
    templateUrl: 'file-preview.template.html',
    exportAs: 'filePreview',
    styleUrls: ['file-preview.css']
})
export class FilePreviewComponent implements OnInit {

    public previewData: any = {name: '', 'file_groups': []};
    private pricingId;
    private filesIdsString;
    private clientId;


    // ===========================================================
    // Init
    // ===========================================================

    constructor(
        public filesService: FilesService,
        private toasterService: ToasterService,
        private route: ActivatedRoute,
    ) {
        this.pricingId = route.snapshot.queryParams['pricing_id'];
        this.clientId = route.snapshot.queryParams['client_id'];
        this.filesIdsString = route.snapshot.queryParams['files'];
    }


    ngOnInit() {
        this.loadFiles();
    }

    dateDisplayFormat(date) {
        try {
            return dateTimeHelper.dateFormatUSA(date, false) + ' ' + dateTimeHelper.get24Time(date, false);
        } catch (e) {
            return '';
        }
    }

    // ===========================================================
    // Load Data
    // ===========================================================

    public loadFiles() {
        this.filesService.getPreviewFiles(this.pricingId, this.filesIdsString, this.clientId)
            .subscribe(
                (res) => {
                    this.previewData = res.data;
                    console.log(this.previewData.file_groups.length);

                }
            )
    }

    // ===========================================================
    // Actions
    // ===========================================================

    public downloadFile(fileId) {

        window.open(this.getFileUrl(fileId), '_self');
    }

    public getFileUrl(fileId) {

        let user = ApplicationUser.getInstance();

        return '/api/v1/files/content/' + fileId + '?Authorization=' + user.getAccessToken();
    }

    get archiveUrl(): any {

        let user = ApplicationUser.getInstance();

        return '/api/v1/files/archive/' + this.clientId + '?Authorization=' + user.getAccessToken();
    }

    downloadZIP() {
        this.filesService.hasArchive(this.clientId)
            .subscribe(
                (res) => {
                    window.open(this.archiveUrl, '_self');
                }, (error) => {
                    let errorData = JSON.parse(error._body);
                    this.toasterService.pop('error', 'Error', errorData.message);
                }
            );
    }

    get is_pdf_preview(): any {
        try {
            if (this.previewData.file_groups.length == 1 && 
                this.previewData.file_groups[0].files.length == 1
            ) {
                return this.previewData.file_groups[0].files[0].extension == 'pdf';
            }
            return this.previewData.file_groups.length > 0 && 
                this.previewData.file_groups[0].files.length > 0;
        } catch (e) {
        }

        return false;
    }

    public saveToPdf() {
        if (! this.is_pdf_preview) return;

        let user = ApplicationUser.getInstance();

        let url = '/api/v1/files/savetopdf?' +
            (this.pricingId ? 'pricing_id=' + this.pricingId + '&' : '') +
            (this.clientId ? 'client_id=' + this.clientId + '&' : '') +
            'files=' + this.filesIdsString + '&Authorization=' + user.getAccessToken();
        window.open(url, '_self');
    }


    // ===========================================================
    // Functions
    // ===========================================================

}


// WEBPACK FOOTER //
// ./src/app/views/file-preview/file-preview.component.ts